import { Moment } from "moment-timezone";
import { useTranslation } from "react-i18next";

export default function SlotTime({ time }: { time: Moment }) {
  const { i18n } = useTranslation();
  return (
    <time dateTime={time.format("YYYY-MM-DDTHH:mm")}>
      {time.locale(i18n.language).format("hh:mm A")}
    </time>
  );
}
